import type { MstCommon } from '@libs/domain';

class LeaseCompanyMstSetting implements Pick<MstCommon['schema'], 'codeDigits'> {
  private constructor(readonly codeDigits: string) {}

  static fromRaw(raw: LeaseCompanyMstSettingRaw) {
    return new LeaseCompanyMstSetting(raw.codeDigits);
  }
}

class LeaseCompanyMstSettingRaw implements Pick<MstCommon['record'], 'codeDigits'> {
  private constructor(readonly codeDigits: string) {}

  static fromModel(mstInfoSetting: LeaseCompanyMstSetting) {
    return new LeaseCompanyMstSettingRaw(mstInfoSetting.codeDigits);
  }
}

export { LeaseCompanyMstSetting, LeaseCompanyMstSettingRaw };
